@if (_active) {
  <div class="assigned-asset-popup-layout"></div>
  <kendo-window class="assigned-asset-popup" title="Notification" (close)="_closeForm()">
    <div class="row">
      <div class="col-12">
        <div class="customPopupHeader">
          <div class="popupHeaderTitle">Notification</div>
          <ul class="popupBouttons">
            <li><a (click)="_onSave()"><span><img [src]="'/assets/menu/'+ _theme +'/save-icon.svg'" /></span>Save</a></li>
            <li>
              <a (click)="_closeForm()"><span><img [src]="'/assets/menu/'+ _theme +'/close-icon.svg'" /></span>close</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12">
        <div class="bodyPopupContainer">
          <div class="popupBodyImage"><img [src]="'/assets/menu/'+ _theme +'/notification-icon.svg'" /></div>
          <div class="popupBodyMessage">
            <div class="row">
              <div class="col-10 row-left">
                <div class="mb-1">Woud you like to deactivate this Person?</div>
                @if (deactivateConfirm.value?.value) {
                  <kendo-combobox #deactivateReason class="status-select" [data]="_reasons"
                    [placeholder]="'Select a reason'">
                  </kendo-combobox>
                }
              </div>
              <kendo-combobox #deactivateConfirm class="col-2" [data]="_statuses" [textField]="'text'"
                [valueField]="'value'" [placeholder]="'Select a Status'">
              </kendo-combobox>
            </div>
            <div class="row">
              <div class="col-10 row-left">
                <div class="mb-1">Woud you like to move these asset to another location?</div>
                @if (locationConfirm.value?.value) {
                  <kendo-combobox #deactivateLocation class="status-select" [data]="_locations"
                    [placeholder]="'Select a location'" [textField]="'code'" [valueField]="'id'">
                  </kendo-combobox>
                }
              </div>
              <kendo-combobox #locationConfirm class="col-2" [data]="_statuses" [textField]="'text'"
                [valueField]="'value'" [placeholder]="'Select a Status'">
              </kendo-combobox>
            </div>
            <div class="row">
              <div class="col-10 row-left">
                <div class="mb-1">Woud you like to move these asset to another person?</div>
                @if (personConfirm.value?.value) {
                  <kendo-combobox #deactivatePerson class="status-select" [data]="_users"
                    [placeholder]="'Select a person'" [textField]="'code'" [valueField]="'id'">
                  </kendo-combobox>
                }
              </div>
              <kendo-combobox #personConfirm class="col-2" [data]="_statuses" [textField]="'text'"
                [valueField]="'value'" [placeholder]="'Select a Status'">
              </kendo-combobox>
            </div>
            <div class="row">
              <div class="col-10 row-left">
                <div class="mb-1">Woud you like to make these asset available for custody?</div>
              </div>
              <kendo-combobox class="col-2" [data]="_statuses" [textField]="'text'" #custodyConfirm
                [valueField]="'value'" [placeholder]="'Select a Status'">
              </kendo-combobox>
            </div>
            <div class="row">
              <div class="col-10 row-left">
                <div class="mb-1">Woud you like to make these asset available for checkout?</div>
              </div>
              <kendo-combobox class="col-2" [data]="_statuses" [textField]="'text'" #checkoutConfirm
                [valueField]="'value'" [placeholder]="'Select a Status'">
              </kendo-combobox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </kendo-window>
}
